import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AnalyticsPageViews from "@/components/AnalyticsPageViews";
import Home from "@/pages/Home";
import BookingView from "@/pages/BookingView";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

function App() {
  return (
    <MotionConfig reducedMotion="user">
    <AuthProvider>
      <BrowserRouter>
        <AnalyticsPageViews />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking/:id" element={<BookingView />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
    </MotionConfig>
  );
}

export default App;
